import {
  AddTerminalRequest,
  AddTerminalResponse,
} from '@ozark/functions/lib/functions/express/private/types';
import {ApiBase} from './ApiBase';

export class TerminalsApi extends ApiBase {
  addTerminal = (body: AddTerminalRequest) => {
    return this.post<AddTerminalResponse>('terminals', body);
  };
}
